document.addEventListener('DOMContentLoaded', function () {

    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        }
    });

    $(document).ready(function() {
        const $loader = $('#global-loader');

        // 1. Handle Standard Form Submits
        $(document).on('submit', 'form', function() {
            // Skip if the form has a special class like 'no-loader'
            if ($(this).hasClass('no-loader')) return;

            $loader.removeClass('d-none');
        });

        let loaderTimeout;

        $(document).ajaxStart(function() {
            // Only show if the request takes longer than 200ms
            loaderTimeout = setTimeout(function() {
                $('#global-loader').removeClass('d-none');
            }, 200);
        });

        // 2. Global AJAX handling with exclusion
        $(document).ajaxSend(function(event, jqXHR, settings) {
            // If the AJAX request has global: false, settings.global will be false
            if (settings.global !== false) {
                $loader.removeClass('d-none');
            }
        });

        $(document).ajaxComplete(function(event, jqXHR, settings) {
            if (settings.global !== false) {
                $loader.addClass('d-none');
            }
        });

        $(document).ajaxStop(function() {
            clearTimeout(loaderTimeout);
            $('#global-loader').addClass('d-none');
        });
    });

    $(document).ready(function() {
        $(document).on('click', '.toggle-password', function() {
            const targetId = $(this).data('target');
            const input = $('#' + targetId);
            const icon = $(this).find('i');

            if (input.attr('type') === 'password') {
                input.attr('type', 'text');
                icon.removeClass('bi-eye').addClass('bi-eye-slash');
            } else {
                input.attr('type', 'password');
                icon.removeClass('bi-eye-slash').addClass('bi-eye');
            }
        });
    });


    $(document).on('click', '.delete-trip-btn', function() {
        const tripId = $(this).data('id');
        const tripTitle = $(this).data('title');

        Swal.fire({
            title: __('Confirm Deletion'),
            html: `${__('To delete')} <strong>"${tripTitle}"</strong>, ${__('please type the trip name below:')}`,
            icon: 'warning',
            input: 'text',
            inputAttributes: {
                autocapitalize: 'off',
                placeholder: tripTitle,
                style: 'text-align: center; width: 87%; box-sizing: border-box;'
            },
            showCancelButton: true,
            confirmButtonColor: '#8c6d6d',
            cancelButtonColor: '#525866',
            confirmButtonText: __('Delete Permanently'),
            cancelButtonText: __('Cancel'),
            customClass: {
                popup: 'rounded-4 border-0 shadow-lg px-3', // Added horizontal padding
                title: 'fw-bold text-dark',
                input: 'form-control rounded-3 border-light-subtle'
            },
            preConfirm: (inputValue) => {
                if (inputValue.toLowerCase() !== tripTitle.toLowerCase()) {
                    Swal.showValidationMessage(__('The name does not match.'));
                    return false;
                }
                return true;
            }
        }).then((result) => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: __('Deleting...'),
                    allowOutsideClick: false,
                    didOpen: () => {
                        Swal.showLoading();
                    }
                });
                $(`#delete-form-${tripId}`).submit();
            }
        });
    });

    /**
     * Helper to extract and stringify Google Places Metadata
     */
    function fillGoogleMetadata(place, targetInputId) {

        const metadata = {
            website: place.website || null,
            phone: place.formatted_phone_number || null,
            rating: place.rating || null,
            reviews_count: place.user_ratings_total || null,
            price_level: place.price_level || null,
            photos: place.photos ? place.photos.slice(0, 3).map(p => p.getUrl({maxWidth: 600})) : [],
            opening_hours: place.opening_hours ? place.opening_hours.weekday_text : null,
            url: place.url || null
        };

        $(`#${targetInputId}`).val(JSON.stringify(metadata));
    }

    /**
     * Logout Handling with SweetAlert2
     */
    $(document).on('click', '#logout-button, #logout-button-mobile', function (e) {
        e.preventDefault();

        Swal.fire({
            title: __('Ready to head out?'),
            text: __("You'll need to sign back in to access your itineraries."),
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#607182', // Slate Info/Steel Blue
            cancelButtonColor: '#525866', // Slate Primary
            confirmButtonText: __('Yes, sign out'),
            cancelButtonText: __('Stay here'),
            reverseButtons: true,
            customClass: {
                popup: 'rounded-4 border-0 shadow-lg',
                title: 'fw-bold text-dark'
            }
        }).then((result) => {
            if (result.isConfirmed) {
                const logoutForm = document.getElementById('logout-form');
                if (logoutForm) {
                    logoutForm.submit();
                }
            }
        });
    });


    /**
     * Edit Trip modal
     */
    $(document).on('click', '.edit-trip-btn', function() {
        const trip = $(this).data('trip');

        $('#editTripForm').attr('action', `/trips/${trip.id}`);
        $('#cloneTripForm').attr('action', `/trips/${trip.id}/duplicate`);
        $('#edit_title').val(trip.title);
        $('#edit_notes').val(trip.notes);

        // Popunjavanje Base Currency
        $('#edit_base_currency').val(trip.base_currency);

        // Popunjavanje Select2 sa Allowed Currencies
        const allowed = Array.isArray(trip.allowed_currencies) ? trip.allowed_currencies : [];
        $('.select2-currencies-edit').val(allowed).trigger('change');

        if (trip.date_from) $('#edit_date_from').val(trip.date_from.split('T')[0]);
        if (trip.date_to) $('#edit_date_to').val(trip.date_to.split('T')[0]);

        $('.edit-travel-check').prop('checked', false);
        if (trip.travel_by) {
            const modes = Array.isArray(trip.travel_by) ? trip.travel_by : JSON.parse(trip.travel_by);
            modes.forEach(mode => {
                $(`#edit_check_${mode}`).prop('checked', true);
            });
        }

        const editModal = window.bootstrap.Modal.getOrCreateInstance(document.getElementById('editTripModal'));
        editModal.show();
    });


    $(document).on('click', '#cloneTripBtn', function(e) {
        e.preventDefault();

        Swal.fire({
            title: __('Duplicate Trip?'),
            text: __("This will create a new copy including all days, activities, wishlist items, and links."),
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#607182', // Slate Info
            cancelButtonColor: '#525866', // Slate Primary
            confirmButtonText: __('Yes, clone it!'),
            cancelButtonText: __('Cancel'),
            reverseButtons: true,
            customClass: {
                popup: 'rounded-4 shadow-sm',
                confirmButton: 'rounded-pill px-4 fw-bold',
                cancelButton: 'rounded-pill px-4 fw-bold'
            }
        }).then((result) => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: __('Cloning...'),
                    text: __('Please wait while we prepare your copy.'),
                    allowOutsideClick: false,
                    didOpen: () => {
                        Swal.showLoading();
                    }
                });
                $('#cloneTripForm').submit();
            }
        });
    });

    /**
     * Set Stay Modal Logic
     */
    $(document).on('click', '.set-stay-btn', function() {

        const btn = $(this);
        const lat = btn.data('lat');
        const lon = btn.data('lon');
        const locationName = btn.data('location-name');

        $('#stay_search').val(btn.data('location-name'));
        $('#stay_location_name').val(btn.data('location-name'));
        $('#stay_lat').val(btn.data('lat'));
        $('#stay_lon').val(btn.data('lon'));
        $('#stay_price').val(btn.data('price'));
        $('#stay_description').val(btn.data('description'));

        const startId = btn.data('range-start');
        const endId = btn.data('range-end');

        if (startId && endId) {
            $('#start_day_id').val(startId);
            $('#end_day_id').val(endId);
        }

        if (lat && lon && locationName) {
            const encodedName = encodeURIComponent(locationName);
            const mapUrl = `https://www.google.com/maps/search/?api=1&query=${encodedName}&query_place_id=${lat},${lon}`;
            $('#stay_directions_link').attr('href', mapUrl);
            $('#stay_directions_wrapper').show();
        } else {
            $('#stay_directions_wrapper').hide();
        }

        const modal = bootstrap.Modal.getOrCreateInstance(document.getElementById('stayModal'));
        modal.show();
    });

    $('.clear_stay_btn').on('click', function() {
        Swal.fire({
            title: __('Remove Stay Location?'),
            text: __("This will clear the sleeping location for all days in the selected range."),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#8c6d6d', // Slate Danger
            cancelButtonColor: '#525866', // Slate Primary
            confirmButtonText: __('Yes, clear it!'),
            cancelButtonText: __('Cancel'),
            reverseButtons: true,
            customClass: {
                popup: 'rounded-4 border-0 shadow-lg'
            }
        }).then((result) => {
            if (result.isConfirmed) {
                $('#stay_search, #stay_location_name, #stay_lat, #stay_lon, #stay_price, #stay_description').val('');
                $('#stayForm').submit();
            }
        });
    });

    /**
     * Journey Logic (Add & Edit)
     */

    function addExpenseRow(title = '', amount = '', currency = '') {
        const container = $('#expense_rows_container');
        const { baseCurrency, allowedCurrencies } = window.TripConfig;

        // Osiguravamo da su vrednosti stringovi kako toUpperCase() ne bi bacao grešku
        const safeCurrency = (currency || '').toUpperCase();
        const safeBaseCurrency = (baseCurrency || '').toUpperCase();

        let currencyOptions = '';
        allowedCurrencies.forEach(curr => {
            const currentOption = curr.toUpperCase();

            // Logika: selektuj ako se poklapa sa prosleđenim ILI ako nema prosleđenog a ovo je baseCurrency
            const isSelected = (safeCurrency === currentOption) || (!safeCurrency && currentOption === safeBaseCurrency);
            const selectedAttr = isSelected ? 'selected' : '';

            currencyOptions += `<option value="${curr}" ${selectedAttr}>${currentOption}</option>`;
        });

        const row = `
        <div class="row g-2 mb-2 expense-row">
            <div class="col-5">
                <input type="text" name="expense_titles[]" class="form-control form-control-sm border-0 bg-light"
                       value="${title}" placeholder="Item name...">
            </div>
            <div class="col-3">
                <input type="number" step="0.01" name="expense_amounts[]" class="form-control form-control-sm border-0 bg-light fw-bold"
                       value="${amount}" placeholder="0.00">
            </div>
            <div class="col-3">
                <select name="expense_currencies[]" class="form-select form-select-sm border-0 bg-light fw-bold">
                    ${currencyOptions}
                </select>
            </div>
            <div class="col-1 text-end">
                <button type="button" class="btn btn-link text-danger p-0 remove-expense-row">
                    <i class="bi bi-x-circle"></i>
                </button>
            </div>
        </div>
    `;
        container.append(row);
    }

    $(document).on('click', '.remove-expense-row', function() {
        $(this).closest('.expense-row').remove();
    });

    function addDocumentRow(title = '') {
        const rowHtml = `
        <div class="row g-2 mb-2 document-row animate__animated animate__fadeIn">
            <div class="col-5">
                <input type="text" name="document_titles[]" value="${title}" class="form-control form-control-sm" placeholder="Title (e.g. Ticket)">
            </div>
            <div class="col-6">
                <input type="file" name="document_files[]" class="form-control form-control-sm" accept=".pdf,image/*">
            </div>
            <div class="col-1 text-end">
                <button type="button" class="btn btn-sm btn-link text-danger p-0 remove-document-row"><i class="bi bi-trash"></i></button>
            </div>
        </div>`;
        $('#document_rows_container').append(rowHtml);
    }

    $(document).on('click', '.remove-document-row', function() {
        $(this).closest('.document-row').remove();
    });

    window.addJourney = function(dayId) {
        const form = $('#journeyForm');
        form.attr('method', 'POST');
        form.attr('action', form.data('store-url'));
        form.find('input[name="_method"]').remove();
        form[0].reset();

        $('#expense_rows_container').empty();
        $('#document_rows_container').empty();
        $('#existing_documents_container').empty().addClass('d-none');
        $('#removed_docs_container').empty();
        $('#move_day_container').addClass('d-none');

        $('#journey_day_id').val(dayId);
        $('#journey_metadata').val('');
        $('#journeyModal .modal-title').text(__('Add Journey / Activity'));

        if ($(window).width() <= 768) {
            $('#journeyModal .modal-footer').removeClass('flex-row-reverse');
        }

        bootstrap.Modal.getOrCreateInstance(document.getElementById('journeyModal')).show();
    };

    window.openEditJourneyModal = function(journey) {
        const form = $('#journeyForm');
        const isGroup = $('#add_expense_row').data('is-group') === true;

        $('#move_day_container').removeClass('d-none');
        form.attr('action', `/journeys/${journey.id}`);

        if (form.find('input[name="_method"]').length === 0) {
            form.prepend('<input type="hidden" name="_method" value="PUT">');
        }

        $('#journey_day_id').val(journey.trip_day_id);
        $('#edit_journey_day_id').val(journey.trip_day_id);

        form.find('input[name="time_from"]').val(journey.time_from ? journey.time_from.substring(0, 5) : '');
        form.find('input[name="time_to"]').val(journey.time_to ? journey.time_to.substring(0, 5) : '');

        $('#journey_search').val(journey.location_name);
        $('#journey_location_name').val(journey.location_name);
        $('#journey_title').val(journey.title);
        $('#journey_address').val(journey.address);
        $('#journey_lat').val(journey.lat);
        $('#journey_lon').val(journey.lon);
        form.find('textarea[name="description"]').val(journey.description);

        const metaValue = (typeof journey.google_metadata === 'object' && journey.google_metadata !== null)
            ? JSON.stringify(journey.google_metadata)
            : (journey.google_metadata || '');
        $('#journey_metadata').val(metaValue);

        form.find('input[name="travel_by[]"]').prop('checked', false);
        if (journey.travel_by) {
            const modes = Array.isArray(journey.travel_by) ? journey.travel_by : JSON.parse(journey.travel_by);
            modes.forEach(mode => {
                $(`#btn_${mode}`).prop('checked', true);
            });
        }

        $('#expense_rows_container').empty();
        if (journey.expenses) {
            journey.expenses.forEach(exp => {
                if(typeof addExpenseRow === 'function') {
                    addExpenseRow(exp.title, exp.amount, exp.currency);
                }
            });
        }

        $('#document_rows_container').empty();
        $('#existing_documents_container').empty().addClass('d-none');
        $('#removed_docs_container').empty();

        if (journey.documents && journey.documents.length > 0) {
            $('#existing_documents_container').removeClass('d-none');
            journey.documents.forEach(doc => {
                const isPdf = doc.file_type === 'pdf' || doc.file_path.toLowerCase().endsWith('.pdf');
                const icon = isPdf ? 'file-earmark-pdf text-danger' : 'file-earmark-image text-info';
                const docHtml = `
                <div class="d-flex align-items-center justify-content-between bg-white p-2 rounded mb-2 border shadow-sm existing-doc-item">
                    <div class="small text-truncate me-2">
                        <i class="bi bi-${icon} me-1"></i>
                        <span title="${doc.title}">${doc.title}</span>
                    </div>
                    <div class="d-flex gap-2 align-items-center">
                        <a href="/storage/${doc.file_path}" target="_blank" class="btn btn-xs btn-outline-info py-0 px-2 fw-bold" style="font-size: 0.7rem; text-transform: uppercase">
                            ${__('View')}
                        </a>
                        <button type="button" class="btn btn-link text-danger p-0 ms-1 delete-stored-doc" data-id="${doc.id}"><i class="bi bi-x-circle"></i></button>
                    </div>
                </div>`;
                $('#existing_documents_container').append(docHtml);
            });
        }

        if ($(window).width() <= 768) {
            $('#journeyModal .modal-footer').addClass('flex-row-reverse');
        }

        $('#journeyModal .modal-title').html(`<i class="bi bi-pencil-square me-2"></i>${__('Edit Activity')}`);
        bootstrap.Modal.getOrCreateInstance(document.getElementById('journeyModal')).show();
    };

    $(document).on('click', '.clickable-journey-card', function(e) {
        if ($(e.target).closest('.dropdown, .dropdown-menu, a, button, form').length) {
            return;
        }
        const journey = $(this).data('journey');
        window.openEditJourneyModal(journey);
    });

    $(document).on('click', '.edit-journey-btn', function(e) {
        e.preventDefault();
        e.stopPropagation();
        const journey = $(this).data('journey');
        window.openEditJourneyModal(journey);
    });

    $(document).on('change', '#edit_journey_day_id', function() {
        $('#journey_day_id').val($(this).val());
    });

    $(document).on('click', '.dropdown-menu', function(e) {
        e.stopPropagation();
    });

    $(document).on('click', '#add_expense_row', function() {
        addExpenseRow('', '', '');
    });

    $(document).on('click', '#add_document_row', function() {
        addDocumentRow();
    });

    $(document).on('submit', '.delete-journey-form', function(e) {
        e.preventDefault();
        const formElement = this;

        Swal.fire({
            title: __('Recycle Activity?'),
            text: __("This will move the item back to your Wishlist Trashed category."),
            icon: 'info',
            showCancelButton: true,
            confirmButtonText: __('Move to Wishlist'),
            cancelButtonText: __('Cancel'),
            confirmButtonColor: '#8a7a5e', // Slate Warning/Gold
            cancelButtonColor: '#525866',
        }).then((result) => {
            if (result.isConfirmed) {
                $('#global-loader').removeClass('d-none');
                formElement.submit();
            }
        });
    });


    $(document).on('submit', '.permanent-delete-journey-form', function(e) {
        e.preventDefault();
        const formElement = this;

        Swal.fire({
            title: __('Delete Activity?'),
            text: __("This will permanently remove this activity and all attached expenses/documents."),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#8c6d6d', // Slate Danger
            cancelButtonColor: '#525866',
            confirmButtonText: __('Yes, delete it!'),
            cancelButtonText: __('Cancel'),
            reverseButtons: true,
        }).then((result) => {
            if (result.isConfirmed) {
                $('#global-loader').removeClass('d-none');
                formElement.submit();
            }
        });
    });


    $(document).on('click', '.delete-stored-doc', function() {
        const btn = $(this);
        const docId = btn.data('id');
        const container = btn.closest('.existing-doc-item');

        container.fadeOut(300, function() {
            $(this).remove();
            $('#removed_docs_container').append(`<input type="hidden" name="detached_document_ids[]" value="${docId}">`);
            if ($('#existing_documents_container').children().length === 0) {
                $('#existing_documents_container').addClass('d-none');
            }
        });
    });


    function initGoogleAutocompletes() {
        const stayInput = document.getElementById('stay_search');
        if (stayInput && typeof google !== 'undefined') {
            const stayAutocomplete = new google.maps.places.Autocomplete(stayInput);
            stayAutocomplete.addListener('place_changed', function() {
                const place = stayAutocomplete.getPlace();
                if (!place.geometry) return;

                let city = '';
                if (place.address_components) {
                    const cityComponent = place.address_components.find(c =>
                        c.types.includes('locality') ||
                        c.types.includes('administrative_area_level_3') ||
                        c.types.includes('postal_town')
                    );
                    city = cityComponent ? cityComponent.long_name : '';
                }

                let displayName = place.name || place.formatted_address;
                if (city && !displayName.includes(city)) {
                    displayName = `${displayName}, ${city}`;
                }

                $('#stay_location_name').val(displayName);
                $('#stay_lat').val(place.geometry.location.lat());
                $('#stay_lon').val(place.geometry.location.lng());
                $('#stay_search').val(displayName);
            });
        }

        const journeyInput = document.getElementById('journey_search');
        const journeyNameHidden = document.getElementById('journey_location_name');

        if (journeyInput && typeof google !== 'undefined') {
            const journeyAutocomplete = new google.maps.places.Autocomplete(journeyInput);
            journeyAutocomplete.setFields(['geometry', 'name', 'formatted_address', 'website', 'formatted_phone_number', 'rating', 'user_ratings_total', 'price_level', 'photos', 'opening_hours', 'url']);

            journeyInput.addEventListener('input', function() {
                //journeyNameHidden.value = this.value;
                $('#journey_lat, #journey_lon, #journey_metadata, #journey_address').val('');
            });

            journeyAutocomplete.addListener('place_changed', function() {
                const place = journeyAutocomplete.getPlace();
                if (place.geometry) {
                    $(journeyNameHidden).val(place.name || place.formatted_address);

                    // Fill the new 'title' field instead of description
                    const titleField = $('#journey_title');
                    if (titleField.length) {
                        titleField.val(place.name);
                        setTimeout(() => titleField.focus(), 100);
                    }

                    $('#journey_address').val(place.formatted_address);
                    $('#journey_lat').val(place.geometry.location.lat());
                    $('#journey_lon').val(place.geometry.location.lng());
                    fillGoogleMetadata(place, 'journey_metadata');
                } else {
                    $(journeyNameHidden).val('');
                }
            });
        }

        const wishlistInput = document.getElementById('wishlist_search');
        if (wishlistInput && typeof google !== 'undefined') {
            const wishlistAutocomplete = new google.maps.places.Autocomplete(wishlistInput);
            wishlistAutocomplete.setFields(['geometry', 'name', 'formatted_address', 'website', 'formatted_phone_number', 'rating', 'user_ratings_total', 'price_level', 'photos', 'opening_hours', 'url']);

            wishlistAutocomplete.addListener('place_changed', function() {
                const place = wishlistAutocomplete.getPlace();
                if (!place.geometry) return;
                $('#w_name').val(place.name);
                $('#w_address').val(place.formatted_address);
                $('#w_lat').val(place.geometry.location.lat());
                $('#w_lon').val(place.geometry.location.lng());
                fillGoogleMetadata(place, 'w_metadata');
            });
        }
    }

    if (typeof google === 'undefined') {
        window.addEventListener('load', initGoogleAutocompletes);
    } else {
        initGoogleAutocompletes();
    }

    $(document).on('keydown', '#journey_search', function(e) {
        if (e.keyCode === 13 && $('.pac-container:visible').length) {
            e.preventDefault();
        }
    });

    $(document).ready(function() {
        const stepper = $('.itinerary-stepper');
        const tripId = stepper.data('trip-id');
        if (!tripId) return;

        const storageKey = `trip_${tripId}_expanded_days`;
        let expandedDays = JSON.parse(localStorage.getItem(storageKey)) || [];

        $('.day-collapse-instance').each(function() {
            const dayId = $(this).data('day-id').toString();
            if (expandedDays.includes(dayId)) {
                $(this).addClass('show');
                $(this).prev('.day-header').find('.collapse-icon').addClass('rotate-180');
            }
        });

        $(document).on('click', '#toggle-all-days', function() {
            const allCollapsibles = $('.day-collapse-instance');
            const isExpanding = Array.from(allCollapsibles).some(el => !$(el).hasClass('show'));

            allCollapsibles.each(function() {
                const bsCollapse = bootstrap.Collapse.getOrCreateInstance(this);
                isExpanding ? bsCollapse.show() : bsCollapse.hide();
            });

            const icon = $(this).find('i');
            if (isExpanding) {
                icon.removeClass('bi-arrows-expand').addClass('bi-arrows-collapse');
            } else {
                icon.removeClass('bi-arrows-collapse').addClass('bi-arrows-expand');
            }
        });

        $('.day-collapse-instance').on('shown.bs.collapse', function () {
            const dayId = $(this).data('day-id').toString();
            $(this).prev('.day-header').find('.collapse-icon').addClass('rotate-180');
            if (!expandedDays.includes(dayId)) {
                expandedDays.push(dayId);
                localStorage.setItem(storageKey, JSON.stringify(expandedDays));
            }
        });

        $('.day-collapse-instance').on('hidden.bs.collapse', function () {
            const dayId = $(this).data('day-id').toString();
            $(this).prev('.day-header').find('.collapse-icon').removeClass('rotate-180');
            expandedDays = expandedDays.filter(id => id !== dayId);
            localStorage.setItem(storageKey, JSON.stringify(expandedDays));
        });
    });

    $(document).on('show.bs.collapse', '.itinerary-stepper .collapse', function (e) {
        $(`[data-bs-target="#${e.target.id}"]`).find('.collapse-icon').addClass('rotate-180');
    });

    $(document).on('hide.bs.collapse', '.itinerary-stepper .collapse', function (e) {
        $(`[data-bs-target="#${e.target.id}"]`).find('.collapse-icon').removeClass('rotate-180');
    });

    if (window.innerWidth < 768) {
        const scrollToSelector = document.querySelector('#scrollToMeOnMobile');
        if (scrollToSelector) {
            setTimeout(() => {
                scrollToSelector.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }, 300);
        }
    }


    /**
     * FAB Speed Dial Toggle
     */
    $(document).on('click', '#fabTrigger', function(e) {
        e.stopPropagation();
        $('#fabMenu').toggleClass('active');
    });

    $(document).on('click', function(e) {
        if (!$(e.target).closest('#fabMenu').length) {
            $('#fabMenu').removeClass('active');
        }
    });

    $(document).on('click', '.fab-options button', function() {
        $('#fabMenu').removeClass('active');
    });

    $(document).on('click', '#scrollToTop', function() {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    });


    /**
     * Wishlist to Journey Transfer
     */
    let selectedWishlistItem = null;

    window.prepJourneyFromWishlist = function(item) {
        selectedWishlistItem = item;
        const modal = bootstrap.Modal.getOrCreateInstance(document.getElementById('dayPickerModal'));
        modal.show();
    };

    window.finalizeJourneyTransfer = function(dayId, dayName) {
        const dayPickerEl = document.getElementById('dayPickerModal');
        const dayPickerModal = bootstrap.Modal.getInstance(dayPickerEl) || new bootstrap.Modal(dayPickerEl);
        dayPickerModal.hide();

        const form = $('#journeyForm');
        $('#move_day_container').addClass('d-none');

        form.find('input[name="category_id"]').remove();
        form.find('input[name="wishlist_item_id"]').remove();
        if (selectedWishlistItem && selectedWishlistItem.id) {
            form.append(`<input type="hidden" name="wishlist_item_id" value="${selectedWishlistItem.id}">`);
            if (selectedWishlistItem.category_id) {
                form.append(`<input type="hidden" name="category_id" value="${selectedWishlistItem.category_id}">`);
            }
        }

        $('#journey_day_id').val(dayId);
        $('#journey_search').val(selectedWishlistItem.name);
        $('#journey_location_name').val(selectedWishlistItem.name);
        $('#journey_title').val(selectedWishlistItem.name);
        $('#journey_address').val(selectedWishlistItem.address);
        $('#journey_lat').val(selectedWishlistItem.lat);
        $('#journey_lon').val(selectedWishlistItem.lon);

        if (selectedWishlistItem && selectedWishlistItem.google_metadata) {
            const metaValue = (typeof selectedWishlistItem.google_metadata === 'object')
                ? JSON.stringify(selectedWishlistItem.google_metadata)
                : selectedWishlistItem.google_metadata;
            $('#journey_metadata').val(metaValue);
        }

        setTimeout(() => {
            const jModalEl = document.getElementById('journeyModal');
            const jModal = bootstrap.Modal.getOrCreateInstance(jModalEl);
            jModal.show();
        }, 400);
    };

    /**
     * Wishlist View Management
     */
    $(document).on('change', '#categorySelect', function() {
        $('#newCatWrapper').toggleClass('d-none', $(this).val() !== 'new');
    });

    $(document).on('submit', '.ajax-delete-wishlist', function(e) {
        e.preventDefault();
        const form = $(this);
        const itemId = form.data('id');
        const url = form.attr('action');

        const cardContainer = itemId ? $(`#wishlist-item-${itemId}`) : form.closest('.wishlist-item-container');
        const categoryId = cardContainer.data('category');
        const filterId = categoryId === "" ? 'uncategorized' : `cat-${categoryId}`;

        Swal.fire({
            title: __('Remove from wishlist?'),
            text: __('This idea will be deleted.'),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#8c6d6d', // Slate Danger
            cancelButtonColor: '#525866',
            confirmButtonText: __('Delete'),
            cancelButtonText: __('Cancel'),
            reverseButtons: true,
            customClass: { popup: 'rounded-4' }
        }).then((result) => {
            if (result.isConfirmed) {
                $.ajax({
                    url: url,
                    type: 'POST',
                    data: form.serialize(),
                    success: function(response) {
                        const allBadge = $('.filter-btn[data-category="all"] .badge');
                        let allCount = parseInt(allBadge.text());
                        allBadge.text(allCount - 1);

                        const catBtn = $(`.filter-btn[data-category="${filterId}"]`);
                        const catBadge = catBtn.find('.badge');
                        let catCount = parseInt(catBadge.text());

                        if (catCount > 1) {
                            catBadge.text(catCount - 1);
                        } else {
                            catBtn.fadeOut(300, function() { $(this).remove(); });
                        }

                        const group = cardContainer.closest('.category-group');

                        cardContainer.slideUp(300, function() {
                            $(this).remove();
                            if (group.find('.wishlist-item-container').length === 0) {
                                group.fadeOut(300, function() {
                                    $(this).remove();
                                    if ($('.category-group').length === 0) {
                                        location.reload();
                                    }
                                });
                            }
                        });

                        const Toast = Swal.mixin({
                            toast: true,
                            position: 'top-end',
                            showConfirmButton: false,
                            timer: 2000,
                            timerProgressBar: true
                        });
                        Toast.fire({ icon: 'success', title: __('Item removed') });
                    }
                });
            }
        });
    });

    $(document).on('click', '.change-cat', function(e) {
        e.preventDefault();
        const btn = $(this);
        const itemId = btn.data('id');
        const catId = btn.data('cat-id');
        const tripId = btn.data('trip-id');

        const modalEl = document.getElementById('categoryModal');
        const modalInstance = bootstrap.Modal.getInstance(modalEl);
        if (modalInstance) modalInstance.hide();

        $.ajax({
            url: `/trips/${tripId}/wishlist/${itemId}/update-category`,
            type: 'POST',
            data: {
                _token: $('meta[name="csrf-token"]').attr('content'),
                category_id: catId
            },
            success: function() {
                location.reload();
            },
            error: function() {
                alert(__('Something went wrong. Please try again.'));
            }
        });
    });

    $('.fab-container').on('click', function(e) {
        if (e.target === this && $(this).hasClass('active')) {
            $(this).removeClass('active');
        }
    });

    $(document).on('change', 'select[name="from_day_id"], select[name="to_day_id"]', function() {
        const modal = $('#swapDaysModal');
        const fromId = modal.find('select[name="from_day_id"]').val();
        const toId = modal.find('select[name="to_day_id"]').val();
        const submitBtn = modal.find('button[type="submit"]');

        let errorMsg = modal.find('.swap-error-msg');
        if (errorMsg.length === 0) {
            modal.find('.modal-body').append('<div class="swap-error-msg text-danger small text-center mt-2 d-none">Please select two different days to swap.</div>');
            errorMsg = modal.find('.swap-error-msg');
        }

        if (fromId === toId && fromId !== "") {
            submitBtn.prop('disabled', true).addClass('opacity-50');
            errorMsg.removeClass('d-none');
        } else {
            submitBtn.prop('disabled', false).removeClass('opacity-50');
            errorMsg.addClass('d-none');
        }
    });


    $(document).on('submit', '#swapDaysForm', function(e) {
        e.preventDefault();

        const form = this;
        const fromText = $(form).find('select[name="from_day_id"] option:selected').text();
        const toText = $(form).find('select[name="to_day_id"] option:selected').text();

        Swal.fire({
            title: __('Confirm Day Swap?'),
            html: `${__('You are about to swap all activities between:')}<br>
               <b class="text-info">${fromText}</b> and <b class="text-info">${toText}</b>`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#607182', // Slate Info/Steel Blue
            cancelButtonColor: '#525866',
            confirmButtonText: __('Yes, swap them!'),
            cancelButtonText: __('Cancel'),
            reverseButtons: true,
            customClass: {
                popup: 'rounded-4 border-0 shadow-lg',
                title: 'fw-bold'
            }
        }).then((result) => {
            if (result.isConfirmed) {
                $('#global-loader').removeClass('d-none');
                form.submit();
            }
        });
    });



    // 1. Filtering Logic
    $('.link-filter-btn').on('click', function() {
        const category = $(this).data('category');
        $('.link-filter-btn').removeClass('btn-dark active').addClass('btn-outline-secondary');
        $(this).addClass('btn-dark active').removeClass('btn-outline-secondary');

        if (category === 'all') {
            $('.link-item-container').fadeIn(200);
        } else {
            $('.link-item-container').each(function() {
                $(this).data('category') === category ? $(this).fadeIn(200) : $(this).hide();
            });
        }
    });

    // 2. Search Save Form: Toggle New Category Input
    $('.select-category-save').on('change', function() {
        const input = $(this).siblings('.new-cat-input-save');
        $(this).val() === 'new' ? input.removeClass('d-none').focus() : input.addClass('d-none');
    });

    // 3. AJAX: Change Category (Existing)
    $('.change-link-cat').on('click', function() {
        const linkId = $(this).data('id');
        const catId = $(this).data('cat-id');
        updateLinkCategory(linkId, { link_category_id: catId });
    });

    // 4. AJAX: Change Category (New Inline)
    $('.btn-save-new-cat-inline').on('click', function() {
        const linkId = $(this).data('id');
        const newName = $(this).siblings('.new-cat-inline-input').val();
        if(newName) updateLinkCategory(linkId, { new_link_category_name: newName });
    });

    function updateLinkCategory(id, data) {
        $.ajax({
            url: `/trips/${window.TripConfig.tripId}/useful-links/${id}/update-category`,
            method: 'POST',
            global: false,
            data: {
                ...data,
                _token: window.TripConfig.csrfToken
            },
            success: function() {
                location.reload();
            },
            error: function(xhr) {
                console.error(xhr.responseText);
                alert(__('Error updating category'));
            }
        });
    }

    $(document).on('submit', '.ajax-delete-link', function(e) {
        e.preventDefault();
        const form = $(this);
        const container = form.closest('.link-item-container');

        Swal.fire({
            title: __('Are you sure?'),
            text: __("This link will be permanently removed from your collection."),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#8c6d6d', // Slate Danger
            cancelButtonColor: '#525866',
            confirmButtonText: __('Yes, delete it!'),
            cancelButtonText: __('Cancel'),
            reverseButtons: true
        }).then((result) => {
            if (result.isConfirmed) {
                $.ajax({
                    url: form.attr('action'),
                    method: 'POST',
                    data: form.serialize(),
                    success: function() {
                        container.fadeOut(300, function() {
                            $(this).remove();
                            const Toast = Swal.mixin({
                                toast: true,
                                position: 'top-end',
                                showConfirmButton: false,
                                timer: 2000,
                                timerProgressBar: true
                            });
                            Toast.fire({
                                icon: 'success',
                                title: __('Link deleted')
                            });
                        });
                    },
                    error: function() {
                        Swal.fire(__('Error'), __('Something went wrong.'), 'error');
                    }
                });
            }
        });
    });

    $(document).on('blur', '#manual_url', function() {
        const url = $(this).val();
        if (!url || !url.startsWith('http')) return;

        const $loader = $('#url_loader');
        const $titleInput = $('input[name="title"]');
        const $descInput = $('textarea[name="description"]');

        $loader.removeClass('d-none');

        $.ajax({
            url: `/trips/${window.TripConfig.tripId}/useful-links/fetch-metadata`,
            method: 'POST',
            global: false,
            data: { url: url, _token: window.TripConfig.csrfToken },
            success: function(data) {
                $loader.addClass('d-none');
                if (data.title && !$titleInput.val()) $titleInput.val(data.title);
                if (data.description && !$descInput.val()) $descInput.val(data.description);
            },
            error: function() {
                $loader.addClass('d-none');
            }
        });
    });

    $(document).ready(function() {
        $(document).on('click', '.add-phone-field', function() {
            const fieldHtml = `
            <div class="input-group mb-2 animate__animated animate__fadeIn">
                <input type="text" name="phone_numbers[]" class="form-control" placeholder="Additional number...">
                <button type="button" class="btn btn-outline-danger remove-phone-field">
                    <i class="bi bi-dash-lg"></i>
                </button>
            </div>`;
            $('#phone-inputs-wrapper').append(fieldHtml);
        });

        $(document).on('click', '.remove-phone-field', function() {
            $(this).closest('.input-group').remove();
        });

        $('.ajax-delete-contact').on('submit', function(e) {
            e.preventDefault();
            const form = $(this);
            const card = form.closest('.contact-card-container');

            Swal.fire({
                title: __('Delete Contact?'),
                text: __("All associated phone numbers will be removed."),
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#8c6d6d', // Slate Danger
                cancelButtonColor: '#525866',
                confirmButtonText: __('Yes, delete it!'),
                cancelButtonText: __('Cancel'),
                reverseButtons: true
            }).then((result) => {
                if (result.isConfirmed) {
                    $.ajax({
                        url: form.attr('action'),
                        method: 'POST',
                        data: form.serialize(),
                        success: function() {
                            card.fadeOut(300, function() { $(this).remove(); });
                            Swal.fire({
                                toast: true,
                                position: 'top-end',
                                icon: 'success',
                                title: __('Contact removed'),
                                showConfirmButton: false,
                                timer: 2000
                            });
                        }
                    });
                }
            });
        });
    });

    $(document).on('click', '.edit-contact-btn', function() {
        const contact = $(this).data('contact');
        const url = $(this).data('url');

        $('#editContactForm').attr('action', url);
        $('#edit_name').val(contact.name);
        $('#edit_email').val(contact.email);
        $('#edit_description').val(contact.description);

        const $wrapper = $('#edit-phone-wrapper');
        $wrapper.empty();

        contact.numbers.forEach((num, index) => {
            const isFirst = index === 0;
            const html = `
            <div class="input-group mb-2">
                <input type="text" name="phone_numbers[]" class="form-control" value="${num.phone_number}" required>
                ${!isFirst ? '<button type="button" class="btn btn-outline-danger remove-edit-phone"><i class="bi bi-dash-lg"></i></button>' : ''}
            </div>`;
            $wrapper.append(html);
        });

        const editModal = bootstrap.Modal.getOrCreateInstance('#editContactModal');
        editModal.show();
    });

    $(document).on('click', '.add-edit-phone', function() {
        const html = `
            <div class="input-group mb-2 animate__animated animate__fadeIn">
                <input type="text" name="phone_numbers[]" class="form-control" placeholder="Phone number..." required>
                <button type="button" class="btn btn-outline-danger remove-edit-phone"><i class="bi bi-dash-lg"></i></button>
            </div>`;
        $('#edit-phone-wrapper').append(html);
    });

    $(document).on('click', '.remove-edit-phone', function() {
        $(this).closest('.input-group').remove();
    });

    $(document).on('submit', '.delete-expense-form', function(e) {
        e.preventDefault();
        const form = this;

        Swal.fire({
            title: __('Are you sure?'),
            text: __("This expense will be permanently removed."),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#8c6d6d', // Slate Danger
            cancelButtonColor: '#525866',
            confirmButtonText: __('Yes, delete it!'),
            cancelButtonText: __('Cancel'),
            reverseButtons: true
        }).then((result) => {
            if (result.isConfirmed) {
                $('#global-loader').removeClass('d-none');
                form.submit();
            }
        });
    });

    $(document).on('click', '.edit-expense-btn', function() {

        const expense = $(this).data('expense');
        const trip = $(this).data('trip');
        const participants = $(this).data('participants');
        const url = $(this).data('url');

        $('#editExpenseForm').attr('action', url);
        $('#edit_expense_title').val(expense.title);
        $('#edit_expense_amount').val(expense.amount);
        $('#edit_expense_payer_id').val(expense.payer_id);

        const journeyId = expense.expensable_type.includes('Journey') ? expense.expensable_id : "";
        $('#edit_expense_journey_id').val(journeyId);

        $('.edit-participant-check').prop('checked', false);
        if(participants) {
            participants.forEach(id => {
                $(`#edit_u_${id}`).prop('checked', true);
            });
        }

        const modal = bootstrap.Modal.getOrCreateInstance('#editExpenseModal');
        modal.show();
    });

    $(document).on('submit', '.delete-document-form', function(e) {
        e.preventDefault();

        const form = $(this);
        const url = form.attr('action');
        // Pronalazimo najbližu kolonu pomoću nove klase
        const card = form.closest('.document-col');

        Swal.fire({
            title: __('Delete this document?'),
            text: __("The file will be permanently removed from storage."),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#8c6d6d', // Slate Danger
            cancelButtonColor: '#525866',
            confirmButtonText: __('Yes, delete it!'),
            cancelButtonText: __('Cancel'),
            reverseButtons: true
        }).then((result) => {
            if (result.isConfirmed) {
                $.ajax({
                    url: url,
                    type: 'POST',
                    data: form.serialize(),
                    success: function(response) {
                        if (response.success) {
                            // Animacija koja odmah uklanja element iz DOM-a
                            card.fadeOut(300, function() {
                                $(this).remove();
                            });

                            const Toast = Swal.mixin({
                                toast: true,
                                position: 'top-end',
                                showConfirmButton: false,
                                timer: 2000,
                                timerProgressBar: true
                            });
                            Toast.fire({
                                icon: 'success',
                                title: __('Document deleted')
                            });
                        }
                    },
                    error: function() {
                        Swal.fire(__('Error'), __('Something went wrong. Could not delete the file.'), 'error');
                    }
                });
            }
        });
    });

    $(document).on('click', '.move-doc-btn', function() {
        const docId = $(this).data('doc-id');
        $('#moveDocForm').attr('action', `/documents/${docId}/move`);
    });

    $(document).ready(function () {

        const csrfToken = $('meta[name="csrf-token"]').attr('content');

        $('.sortable-list').each(function () {
            const el = this;
            new Sortable(el, {
                handle: '.drag-handle',
                animation: 150,
                ghostClass: 'bg-light-custom',
                onEnd: function () {

                    const ids = Array.from(el.querySelectorAll('[data-id]'))
                        .filter(child => child.parentElement === el)
                        .map(child => child.dataset.id);

                    const url = $(el).data('reorder-url');

                    $.ajax({
                        url: url,
                        method: 'POST',
                        global: false,
                        data: {
                            _token: csrfToken,
                            ids: ids
                        },
                        error: function() {
                            alert(__('Could not save order. Please refresh.'));
                        }
                    });
                }
            });
        });

        $(document).on('change', '.toggle-item', function () {
            const checkbox = $(this);
            const listItem = checkbox.closest('li');
            const list = listItem.parent();
            const url = checkbox.data('url');

            $.ajax({
                url: url,
                method: 'PATCH',
                global: false,
                data: { _token: csrfToken },
                success: function (data) {
                    if (data.success) {

                        updateListProgress(list)

                        listItem.toggleClass('opacity-50');
                        listItem.find('label').toggleClass('text-decoration-line-through');

                        const callback = function() {
                            const ids = Array.from(list[0].querySelectorAll('li')).map(li => li.dataset.id);
                            const reorderUrl = list.data('reorder-url');
                            $.ajax({
                                url: reorderUrl,
                                method: 'POST',
                                global: false,
                                data: {
                                    _token: csrfToken,
                                    ids: ids
                                }
                            });
                        };

                        if (checkbox.is(':checked')) {
                            listItem.fadeOut(200, function () {
                                $(this).appendTo(list).fadeIn(200, callback);
                            });
                        } else {
                            const firstChecked = list.find('input:checked').first().closest('li');
                            listItem.fadeOut(200, function () {
                                if (firstChecked.length) {
                                    $(this).insertBefore(firstChecked).fadeIn(200, callback);
                                } else {
                                    $(this).prependTo(list).fadeIn(200, callback);
                                }
                            });
                        }
                    }
                }
            });
        });

        $(document).on('click', '.delete-item-btn', function (e) {
            e.preventDefault();

            const button = $(this);
            const form = button.closest('form');
            const itemName = button.closest('li').find('label').text().trim();

            Swal.fire({
                title: __('Remove item?'),
                text: `"${itemName}" ${__('will be deleted.')}`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#8c6d6d', // Slate Danger
                cancelButtonColor: '#525866',
                confirmButtonText: __('Yes, delete it!'),
                cancelButtonText: __('Cancel'),
                reverseButtons: true,
                customClass: { popup: 'rounded-4' }
            }).then((result) => {
                if (result.isConfirmed) {
                    form.submit();
                }
            });
        });

        $(document).on('submit', '.checklist-add-form', function (e) {
            e.preventDefault();

            const form = $(this);
            const list = form.closest('.card-body').find('.sortable-list');
            const input = form.find('input[name="title"]');
            const submitBtn = form.find('button');
            const icon = submitBtn.find('.bi-plus-lg');
            const spinner = submitBtn.find('.spinner-border');

            submitBtn.prop('disabled', true);
            icon.addClass('d-none');
            spinner.removeClass('d-none');

            $.ajax({
                url: form.attr('action'),
                method: 'POST',
                data: form.serialize(),
                global: false,
                success: function (data) {
                    if (data.success) {
                        list.find('.empty-placeholder').remove();

                        const userNameHtml = (data.type === 'shared')
                            ? `<small class="text-muted d-inline-block" style="font-size: 0.65rem;">
                                 <i class="bi bi-person me-1"></i>${data.user_name}
                               </small>`
                            : '';

                        const newItemHtml = `
                            <li class="list-group-item d-flex align-items-center px-0 py-2 border-bottom" data-id="${data.id}" style="display:none;">
                                <i class="bi bi-grip-vertical text-muted me-2 drag-handle" style="cursor: grab;"></i>
                                <div class="form-check flex-grow-1">
                                    <input class="form-check-input toggle-item" type="checkbox" data-url="${data.toggle_url}">
                                    <label class="form-check-label">
                                        ${data.title}
                                        ${userNameHtml}
                                    </label>
                                </div>
                                <form action="${data.delete_url}" method="POST" class="ms-2 no-loader">
                                    <input type="hidden" name="_token" value="${csrfToken}">
                                    <input type="hidden" name="_method" value="DELETE">
                                    <button type="button" class="btn btn-link text-danger p-0 delete-item-btn">
                                        <i class="bi bi-trash"></i>
                                    </button>
                                </form>
                            </li>`;

                        const $newItem = $(newItemHtml);
                        list.prepend($newItem);
                        $newItem.fadeIn(300);

                        input.val('');

                        const ids = Array.from(list[0].querySelectorAll('li')).map(li => li.dataset.id);
                        const reorderUrl = list.data('reorder-url');

                        $.ajax({
                            url: reorderUrl,
                            method: 'POST',
                            data: {
                                _token: csrfToken,
                                ids: ids
                            },
                            global: false
                        });

                        updateListProgress(list);
                    }
                },
                complete: function() {
                    submitBtn.prop('disabled', false);
                    icon.removeClass('d-none');
                    spinner.addClass('d-none');
                },
                error: function() {
                    alert(__('Failed to add item.'));
                }
            });
        });

    });

    function updateListProgress(list) {
        const card = list.closest('.checklist-pane');
        const type = list.data('type');

        const total = list.find('li:not(.empty-placeholder)').length;
        const completed = list.find('input.toggle-item:checked').length;

        const percentage = total > 0 ? Math.round((completed / total) * 100) : 0;

        const progressBar = card.find('.progress-bar');
        const progressText = card.find('.progress-text');

        progressBar.css('width', percentage + '%').attr('aria-valuenow', percentage);
        progressText.text(`${completed}/${total}`);

        const tabCounter = $(`#${type}-counter`);
        if (tabCounter.length) {
            tabCounter.text(`${completed}/${total}`);

            if (total === 0) {
                tabCounter.addClass('bg-light-custom text-dark').removeClass('bg-success-soft text-success');
                progressBar.removeClass('bg-success').addClass('bg-primary');
            } else if (percentage === 100) {
                tabCounter.addClass('bg-success-soft text-success').removeClass('bg-light-custom text-dark');
                progressBar.addClass('bg-success').removeClass('bg-primary');
            } else {
                tabCounter.addClass('bg-light-custom text-dark').removeClass('bg-success-soft text-success');
                progressBar.addClass('bg-primary').removeClass('bg-success');
            }
        }
    }

    $(document).ready(function() {
        $('.sortable-list').each(function() {
            updateListProgress($(this));
        });
    });

    $('button[data-bs-toggle="tab"]').on('shown.bs.tab', function (e) {
        const targetPane = $($(this).data('bs-target'));
        const list = targetPane.find('.sortable-list');
        updateListProgress(list);
    });

    $(document).ready(function () {
        const storageKey = 'last_active_checklist_tab';
        const defaultTab = '#packing-pane';

        let tabToActivate = localStorage.getItem(storageKey) || defaultTab;
        let tabTrigger = $(`button[data-bs-target="${tabToActivate}"]`);

        if (tabTrigger.length === 0) {
            tabTrigger = $(`button[data-bs-target="${defaultTab}"]`);
        }

        if (tabTrigger.length) {
            const tab = new bootstrap.Tab(tabTrigger[0]);
            tab.show();
            $(tabToActivate).addClass('active');
        }

        $('button[data-bs-toggle="tab"]').on('shown.bs.tab', function (e) {
            const target = $(e.target).data('bs-target');
            localStorage.setItem(storageKey, target);
            if (typeof updateListProgress === "function") {
                updateListProgress($(target).find('.sortable-list'));
            }
        });
    });

    $(document).on('click', '.open-cat-modal', function() {
        const btn = $(this);
        const itemId = btn.data('item-id');
        const currentCatId = btn.data('current-cat-id');
        const itemName = btn.data('item-name');

        $('#modal-item-name').text(itemName);
        const modalEl = $('#categoryModal');
        modalEl.data('item-id', itemId);

        const bsModal = new bootstrap.Modal(modalEl[0]);
        bsModal.show();

        renderCategoryList(currentCatId);
    });

    function renderCategoryList(currentId) {
        const categories = window.AppConfig.categories || [];
        const itemId = $('#categoryModal').data('item-id');
        const tripId = window.AppConfig.tripId;

        let html = `
        <button class="list-group-item list-group-item-action change-cat ${!currentId ? 'active' : ''}"
                data-id="${itemId}"
                data-trip-id="${tripId}"
                data-cat-id="">
            <i class="bi bi-dash-circle me-2"></i> Uncategorized
        </button>`;

        categories.forEach(cat => {
            html += `
            <button class="list-group-item list-group-item-action change-cat ${currentId == cat.id ? 'active' : ''}"
                    data-id="${itemId}"
                    data-trip-id="${tripId}"
                    data-cat-id="${cat.id}">
                <i class="bi bi-tag-fill me-2"></i> ${cat.name}
            </button>`;
        });

        $('#category-list-container').html(html);
    }

    $(document).on('click', '#btn-create-move-cat', function() {
        const btn = $(this);
        const itemId = $('#categoryModal').data('item-id');
        const tripId = window.AppConfig.tripId;
        const catName = $('#new-cat-name').val().trim();
        const catColor = $('#new-cat-color').val();

        if (!catName) {
            alert(__('Please enter a category name'));
            return;
        }

        btn.prop('disabled', true).html('<span class="spinner-border spinner-border-sm"></span>');

        $.ajax({
            url: `/trips/${tripId}/wishlist/${itemId}/create-and-move`,
            type: 'POST',
            global: false,
            data: {
                _token: $('meta[name="csrf-token"]').attr('content'),
                name: catName,
                color: catColor
            },
            success: function(response) {
                location.reload();
            },
            error: function(xhr) {
                btn.prop('disabled', false).text('Create & Move');
                alert('Error: ' + (xhr.responseJSON.message || 'Could not create category'));
            }
        });
    });



    let map;
    let markers = [];
    let infoWindow;

    function initDayMap(locations, modalId) {

        const modalEl = document.getElementById(modalId);
        const mapElement = modalEl.querySelector('#map-canvas');

        if (!mapElement) {
            console.error("Map canvas not found in modal: " + modalId);
            return;
        }

        if (!map) {
            map = new google.maps.Map(mapElement, {
                mapId: modalId,
                disableDefaultUI: true,
                zoomControl: true,
                mapTypeControl: true,
                streetViewControl: false,
                fullscreenControl: false,
                gestureHandling: 'greedy',
            });
            infoWindow = new google.maps.InfoWindow();
        } else {
            const mapDiv = map.getDiv();
            if (!mapElement.contains(mapDiv)) {
                mapElement.innerHTML = '';
                mapElement.appendChild(mapDiv);
            }
            google.maps.event.trigger(map, "resize");
        }

        markers.forEach(m => m.setMap(null));
        markers = [];

        const bounds = new google.maps.LatLngBounds();

        locations.forEach((loc, index) => {
            const position = { lat: loc.lat, lng: loc.lng };
            let color = loc.type === 'stay' ? '#4d6459' : '#525866'; // Slate Success vs Slate Primary
            if (modalId === 'visitedMapModal') {
                color = loc.source === 'wishlist' ? '#8c6d6d' : '#4d6459';
            }

            let labelText;
            let fontSize;

            if (modalId === 'dayMapModal') {
                labelText = loc.type === 'stay' ? '⌂' : (index).toString();
                fontSize = loc.type === 'stay' ? '22px' : '13px';
            } else if (modalId === 'visitedMapModal') {
                labelText = '✓';
                fontSize = '18px';
            } else {
                labelText = '♥';
                fontSize = '22px';
            }

            const marker = new google.maps.Marker({
                position: position,
                map: map,
                title: loc.name,
                label: {
                    text: labelText,
                    color: 'white',
                    fontWeight: 'bold',
                    fontSize: fontSize
                },
                icon: {
                    path: google.maps.SymbolPath.CIRCLE,
                    fillColor: color,
                    fillOpacity: .9,
                    strokeWeight: 3,
                    strokeColor: '#FFFFFF',
                    scale: 18
                }
            });

            const timeLabel = loc.time && loc.time !== 'Wishlist'
                ? `<div class="text-muted fw-bold mb-1" style="font-size: 0.65rem; letter-spacing: 0.5px;">${loc.time}</div>`
                : '';

            const directionsUrl = `https://www.google.com/maps/dir/?api=1&destination=${loc.lat},${loc.lng}`;

            const content = `
                <div style="min-width: 160px; line-height: 1.2;">
                    ${timeLabel}
                    <h6 class="fw-bold mb-3" style="font-size: 0.95rem; color: #2d333b;">${loc.name}</h6>
                    <a href="${directionsUrl}"
                       target="_blank"
                       class="btn btn-info btn-sm w-100 rounded-pill d-flex align-items-center justify-content-center py-2 shadow-sm text-white"
                       style="font-size: 0.8rem; font-weight: 600;">
                       <i class="bi bi-send-fill me-2" style="font-size: 0.75rem;"></i> ${__('Directions')}
                    </a>
                </div>`;

            marker.addListener('click', () => {
                infoWindow.setContent(content);
                infoWindow.open(map, marker);
            });

            markers.push(marker);
            bounds.extend(position);
        });

        if (locations.length > 0) {
            map.fitBounds(bounds);
            google.maps.event.addListenerOnce(map, 'idle', () => {
                if (map.getZoom() > 16) map.setZoom(16);
            });
        }
    }

    $(document).on('click', '.open-map', function() {
        const locations = $(this).data('locations');
        const title = $(this).data('day-title');
        const modalId = $(this).data('modal-id');

        $('#mapModalLabel').text(title);

        const modalElement = document.getElementById(modalId);
        const modalInstance = bootstrap.Modal.getOrCreateInstance(modalElement);
        modalInstance.show();

        setTimeout(() => {
            initDayMap(locations, modalId);
        }, 400);
    });

    $(document).on('click', '.filter-btn', function() {
        const btn = $(this);
        const category = btn.data('category');
        const mapBtn = $('#btn-wishlist-map');
        const allLocations = window.AppConfig.wishlistLocations || [];

        $('.filter-btn').removeClass('btn-dark active').addClass('btn-outline-secondary');
        btn.addClass('btn-dark active').removeClass('btn-outline-secondary');

        if (category === 'all') {
            $('.wishlist-item-container').fadeIn(300);
        } else {
            $('.wishlist-item-container').each(function() {
                if ($(this).data('category') === category) {
                    $(this).fadeIn(300);
                } else {
                    $(this).fadeOut(300);
                }
            });
        }

        let filteredLocations;
        if (category === 'all') {
            filteredLocations = allLocations;
        } else {
            filteredLocations = allLocations.filter(loc => loc.category_id === category);
        }

        if (filteredLocations.length === 0) {
            mapBtn.addClass('d-none');
        } else {
            mapBtn.removeClass('d-none').data('locations', filteredLocations);
            const count = filteredLocations.length;
            mapBtn.find('span.count-text').text(`View ${count} on Map`);
        }
    });


    /**
     * Wishlist: toggle "visited" state
     */
    $(document).on('click', '.toggle-visited-btn', function(e) {
        e.preventDefault();
        const btn = $(this);
        const card = $(`#wishlist-item-${btn.data('item-id')}`);

        $.ajax({
            url: btn.data('url'),
            type: 'POST',
            data: { _method: 'PATCH' },
            global: false,
            success: function(response) {
                const visited = !!response.visited;
                btn.toggleClass('text-success', visited).toggleClass('text-muted', !visited)
                    .attr('title', visited ? __('Mark as not visited') : __('Mark as visited'));
                btn.find('i').toggleClass('bi-check-circle-fill', visited).toggleClass('bi-check2-circle', !visited);
                card.find('.wishlist-visited-badge').toggleClass('d-none', !visited);

                Swal.fire({
                    toast: true,
                    position: 'top-end',
                    icon: 'success',
                    title: response.message,
                    showConfirmButton: false,
                    timer: 1800
                });
            },
            error: function() {
                Swal.fire(__('Error'), __('Something went wrong. Please try again.'), 'error');
            }
        });
    });

    /**
     * Visited places: filter by source (plan / wishlist)
     */
    $(document).on('click', '.visited-filter-btn', function() {
        const btn = $(this);
        const source = btn.data('source');
        const mapBtn = $('#btn-visited-map');
        const allLocations = (window.AppConfig && window.AppConfig.visitedLocations) || [];

        $('.visited-filter-btn').removeClass('btn-dark active').addClass('btn-outline-secondary');
        btn.addClass('btn-dark active').removeClass('btn-outline-secondary');

        $('.visited-section').each(function() {
            const show = source === 'all' || $(this).data('source') === source;
            show ? $(this).fadeIn(200) : $(this).fadeOut(200);
        });

        const filtered = source === 'all' ? allLocations : allLocations.filter(loc => loc.source === source);

        if (filtered.length === 0) {
            mapBtn.addClass('d-none');
        } else {
            mapBtn.removeClass('d-none').data('locations', filtered);
        }
    });

    const emailContainer = document.getElementById('email-inputs');
    const addButton = document.getElementById('add-email');

    if (addButton && emailContainer) {
        addButton.addEventListener('click', function () {
            const div = document.createElement('div');
            div.className = 'input-group mb-2 animate__animated animate__fadeIn';
            div.innerHTML = `
                <input type="email" name="emails[]" class="form-control" placeholder="friend@example.com" required>
                <button type="button" class="btn btn-outline-danger remove-field"><i class="bi bi-dash"></i></button>
            `;
            emailContainer.appendChild(div);
        });

        emailContainer.addEventListener('click', function (e) {
            if (e.target.closest('.remove-field')) {
                e.target.closest('.input-group').remove();
            }
        });
    }

    $(document).on('change', '.update-role', function () {
        const url = this.dataset.url;
        const role = this.value;

        fetch(url, {
            method: 'PATCH',
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            body: JSON.stringify({ role: role })
        })
            .then(res => res.json())
            .then(data => {
                const Toast = Swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 2000
                });
                Toast.fire({ icon: 'success', title: __('Permissions updated') });
            })
            .catch(err => console.error(err));
    });

    $(document).on('submit', '.delete-companion-form', function(e) {
        e.preventDefault();
        const form = this;

        Swal.fire({
            title: __('Remove Companion?'),
            text: __("They will lose access to this trip itinerary."),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#8c6d6d', // Slate Danger
            cancelButtonColor: '#525866',
            confirmButtonText: __('Yes, remove them!'),
            cancelButtonText: __('Cancel'),
            reverseButtons: true
        }).then((result) => {
            if (result.isConfirmed) {
                form.submit();
            }
        });
    });

    $(document).on('click', '.settle-btn', function() {
        const data = $(this).data();

        Swal.fire({
            title: __('Confirm Payment'),
            text: `${__('Are you sure you want to mark')} ${data.amount} ${__('as paid to')} ${data.name}?`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#5e7066', // Slate Success
            cancelButtonColor: '#525866',
            confirmButtonText: __('Yes, settled!'),
            cancelButtonText: __('Cancel'),
        }).then((result) => {
            if (result.isConfirmed) {
                $('#s_from').val(data.from);
                $('#s_to').val(data.to);
                $('#s_amount').val(data.amount);
                $('#settleForm').submit();
            }
        });
    });

    $(document).on('submit', '.unsettle-form', function(e) {
        e.preventDefault();
        Swal.fire({
            title: __('Revert Settlement?'),
            text: __("This will put the debt back into the balance sheet."),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#8c6d6d', // Slate Danger
            confirmButtonText: __('Yes, revert it'),
            cancelButtonText: __('Cancel'),
        }).then((result) => {
            if (result.isConfirmed) {
                this.submit();
            }
        });
    });

    $(document).ready(function() {
        const settlementId = 'settlement_collapsed';
        const collapseElement = document.getElementById('settlementCollapse');
        const $chevron = $('#settlementChevron');

        if (!collapseElement) return;

        const bsCollapse = new bootstrap.Collapse(collapseElement, {
            toggle: false
        });

        if (localStorage.getItem(settlementId) === 'true') {
            bsCollapse.hide();
            $chevron.css('transform', 'rotate(-90deg)');
        }

        $(document).on('click', '#toggleSettlement', function() {
            const isCurrentlyShown = collapseElement.classList.contains('show');

            if (isCurrentlyShown) {
                bsCollapse.hide();
                $chevron.css('transform', 'rotate(-90deg)');
                localStorage.setItem(settlementId, 'true');
            } else {
                bsCollapse.show();
                $chevron.css('transform', 'rotate(0deg)');
                localStorage.setItem(settlementId, 'false');
            }
        });
    });

    $(document).on('click', 'a[href*="pdf"]', function(e) {
        const $btn = $(this);
        const originalHtml = $btn.html();

        $btn.addClass('disabled').html('<span class="spinner-border spinner-border-sm me-1"></span>');

        const Toast = Swal.mixin({
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
        });

        Toast.fire({
            icon: 'success',
            title: __('Generating PDF...')
        });

        setTimeout(() => {
            $btn.removeClass('disabled').html(originalHtml);
        }, 4000);
    });

    $(document).on('change', '#is_paid', function() {
        if($(this).is(':checked')) {
            $('#payer_selection_wrapper').slideDown();
        } else {
            $('#payer_selection_wrapper').slideUp();
            $('select[name="payer_id"]').val(''); // Clear payer for Future Expense
        }
    });

    $(document).on('click', '#ps_pay_full', function() {

        let rawDebt = $('#ps_total_debt').text();


        let fullAmount = parseFloat(rawDebt.replace(/,/g, ''));


        if (!isNaN(fullAmount) && fullAmount > 0) {

            $('#ps_amount').val(fullAmount.toFixed(2));
            $('#ps_amount').addClass('is-valid');
            setTimeout(() => {
                $('#ps_amount').removeClass('is-valid');
            }, 500);
        }
    });

    $(document).on('change', '#expense_payer_id', function() {
        const isFuture = $(this).val() === "";
        const submitBtn = $(this).closest('form').find('button[type="submit"]');

        if (isFuture) {
            submitBtn.removeClass('btn-dark').addClass('btn-outline-warning');
            // Optional: you could uncheck other participants if it's a future expense
        } else {
            submitBtn.addClass('btn-dark').removeClass('btn-outline-warning');
        }
    });

    $(document).on('click', '.partial-settle-btn', function() {
        const fromId = $(this).data('from');
        // Get the name of the person who owes money
        const fromName = $(this).data('from-name');
        const toId = $(this).data('to');
        const amount = parseFloat($(this).data('amount'));
        const toName = $(this).data('name');

        $('#ps_from').val(fromId);
        $('#ps_to').val(toId);
        $('#ps_amount').val(amount.toFixed(2));
        $('#ps_total_debt').text(amount.toFixed(2));

        // Set both names in the sentence
        $('#ps_payer_name').text(fromName);
        $('#ps_receiver_name').text(toName);

        const modal = bootstrap.Modal.getOrCreateInstance('#partialSettleModal');
        modal.show();
    });

    $(document).ready(function() {
        $('.select2-currencies').select2({
            theme: 'bootstrap-5',
            width: '100%',
            placeholder: __('Select currencies...'),
            dropdownParent: $('#createTripModal'), // Da bi radilo u modalu
            containerCssClass: 'slate-select2'
        });
    });

    $(document).ready(function() {
        $('.select2-currencies-edit').select2({
            theme: 'bootstrap-5',
            width: '100%',
            placeholder: __('Select currencies...'),
            dropdownParent: $('#editTripModal'),
            closeOnSelect: false
        });
    });

    $(document).ready(function() {
        const $searchToggle = $('#toggle-search');
        const $searchInput = $('#trip-search-input');
        const $tripCards = $('.trip-card');
        const $tripsWrapper = $('#trips-wrapper');

        $searchInput.attr('placeholder', __('Search trips...'));

        $searchToggle.on('click', function() {
            $searchInput.toggleClass('search-input-active');
            if (window.innerWidth < 768) {
                // Dodajemo ili sklanjamo klasu koja smanjuje i opacity i fizički prostor
                $('h1').toggleClass('h1-compact');
            }

            if ($searchInput.hasClass('search-input-active')) {
                $searchInput.focus();
                $(this).html('<i class="bi bi-x-lg"></i>');
            } else {
                $searchInput.val('');
                filterTrips('');
                $(this).html('<i class="bi bi-search"></i>');
            }
        });

        $searchInput.on('input', function() {
            filterTrips($(this).val().toLowerCase());
        });

        function filterTrips(query) {
            let visibleCount = 0;

            $tripCards.each(function() {
                const title = $(this).data('title');

                if (title.indexOf(query) !== -1) {
                    $(this).removeClass('d-none');
                    visibleCount++;
                } else {
                    $(this).addClass('d-none');
                }
            });

            const $noResultsMsg = $('#no-search-results');

            if (visibleCount === 0 && query !== '') {
                if ($noResultsMsg.length === 0) {
                    $tripsWrapper.append(`
                    <div id="no-search-results" class="col-12 text-center py-5">
                        <p class="text-muted">${__('No trips match your search.')}</p>
                    </div>
                `);
                }
            } else {
                $noResultsMsg.remove();
            }
        }
    });

    $(document).ready(function() {
        const dropdownElementList = [].slice.call(document.querySelectorAll('.dropdown-toggle'));
        dropdownElementList.map(function (dropdownToggleEl) {
            return new bootstrap.Dropdown(dropdownToggleEl, {
                popperConfig: function (defaultBsPopperConfig) {
                    return {
                        ...defaultBsPopperConfig,
                        strategy: 'fixed',
                        modifiers: [
                            ...defaultBsPopperConfig.modifiers || [],
                            {
                                name: 'preventOverflow',
                                options: {
                                    boundary: 'viewport',
                                },
                            },
                        ],
                    };
                }
            });
        });
    });



    $(document).ready(function() {
        const grid = document.getElementById('notes-grid');
        if (!grid) return;

        const storeUrl = grid.dataset.storeUrl;

        const modalEl = document.getElementById('addNoteModal');
        if (!modalEl) return;
        const noteModal = new bootstrap.Modal(modalEl);

        const noteForm = document.getElementById('noteForm');
        const methodWrapper = document.getElementById('method_field_wrapper');
        const imageContainer = document.getElementById('current_image_container');
        const imagePreview = document.getElementById('note_image_preview');

        $('[data-bs-target="#addNoteModal"]').on('click', function() {
            noteForm.reset();
            noteForm.action = storeUrl;
            methodWrapper.innerHTML = '';
            imageContainer.classList.add('d-none');
            document.getElementById('remove_image_check').checked = false;
        });

        $(document).on('click', '.edit-note-btn', function() {
            const note = $(this).data('note');

            noteForm.action = `/notes/${note.id}`;
            methodWrapper.innerHTML = '<input type="hidden" name="_method" value="PUT">';

            document.getElementById('note_title').value = note.title || '';
            document.getElementById('note_content').value = note.content || '';
            document.getElementById('remove_image_check').checked = false;

            if (note.image_path) {
                imagePreview.src = `/storage/${note.image_path}`;
                imageContainer.classList.remove('d-none');
            } else {
                imageContainer.classList.add('d-none');
            }

            const myModal = new bootstrap.Modal(document.getElementById('addNoteModal'));
            myModal.show();
        });

        $(document).on('click', '.delete-note-btn', function() {
            const id = $(this).data('id');
            const title = $(this).data('title');
            const noteElement = document.getElementById(`note-${id}`);

            Swal.fire({
                title: __('Are you sure?'),
                text: `${__('This note will be deleted.')} (${title})`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#8c6d6d',
                cancelButtonColor: '#525866',
                confirmButtonText: __('Delete'),
                cancelButtonText: __('Cancel'),
                reverseButtons: true
            }).then((result) => {
                if (result.isConfirmed) {
                    fetch(`/notes/${id}`, {
                        method: 'DELETE',
                        headers: {
                            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
                            'Accept': 'application/json'
                        }
                    })
                        .then(res => res.json())
                        .then(data => {
                            if (data.status === 'success') {
                                $(noteElement).fadeOut(300, function() { $(this).remove(); });
                            }
                        });
                }
            });
        });

    });

    $(document).on('click', '#toggle-textarea-expand', function() {
        const btn = $(this);
        const textarea = $('#note_content');
        const wrapper = btn.closest('.textarea-wrapper');
        const icon = btn.find('i');

        textarea.toggleClass('fullscreen-textarea');
        wrapper.toggleClass('is-fullscreen');

        if (textarea.hasClass('fullscreen-textarea')) {
            icon.removeClass('bi-arrows-fullscreen').addClass('bi-fullscreen-exit');
            textarea.focus();
        } else {
            icon.removeClass('bi-fullscreen-exit').addClass('bi-arrows-fullscreen');
        }
    });

    $(document).on('keydown', function(e) {
        if (e.key === "Escape" && $('#note_content').hasClass('fullscreen-textarea')) {
            $('#toggle-textarea-expand').click();
        }
    });

});
